export const DELAY_MS_SHOW = 800;
export const DELAY_MS_HIDE = 200;
